export default __webpack_public_path__ + "5e7382c63da0098d634a356ff441614e.ttf";